export const faqUrls = {
  // User Management
  '/users':
    'https://oppizi-ltd.atlassian.net/wiki/external/YzA5MGFhYmU2NGQxNDJhYWI3MGIyNGE3ZmQwZTM1YjI',
  '/users/create':
    'https://oppizi-ltd.atlassian.net/wiki/external/NzkyMjhkYWIxNTk5NDY0ZmFiNGZmZDRiODEwN2ZhMmY',
  // Settings
  '/settings/document-types':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDEwYmIyYjI5YjRlNDMxMmI4OTQ3MmRmNzdhNjIzN2I',
  '/settings/invoice-export':
    'https://oppizi-ltd.atlassian.net/wiki/external/NWRkN2UwYTY3YWNiNDQ0ZTk0NWY2M2JjZmIyZmNmZDE',
  '/settings/tags-management':
    'https://oppizi-ltd.atlassian.net/wiki/external/MTQ0ZGE5ZmYzNzFhNDIwNjg2MjY3Y2UyZDliNjNhYjA',
  '/settings/legal-documents':
    'https://oppizi-ltd.atlassian.net/wiki/external/MTE3YWZjYWVmNGY4NGJlMWI3ODBlNTRjMmY0ODEzMWY',
  '/settings/nps-score':
    'https://oppizi-ltd.atlassian.net/wiki/external/NGJiNjlkNDE0MGIyNGNhMDllYTVmYmU1NDc3N2I3ZTQ',
  '/settings/url-shortener':
    'https://oppizi-ltd.atlassian.net/wiki/external/NDhjZmZjZDdhYmFlNDI1OTg0ODEzMzY0NmZmODE2MGU',
  // Chat
  '/chatV2':
    'https://oppizi-ltd.atlassian.net/wiki/external/NWU0Y2ZiZDhiNzZjNGE0Y2JjNjFiYTRmNzAxOTE4Njk',
  // Clients
  '/clients':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDhlNGI3NTk5YmU1NGE4MTlmNzM3Nzk5NjEzMGNhNmM',
  '/clients/:id':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDhlNGI3NTk5YmU1NGE4MTlmNzM3Nzk5NjEzMGNhNmM',
  '/clients/add':
    'https://oppizi-ltd.atlassian.net/wiki/external/MDkwYmU4NjE5OWY5NGM4NjkyM2ZlNzA3ZDUxMWU4NTY',
  // Countries
  '/countries/:id/global-planing':
    'https://oppizi-ltd.atlassian.net/wiki/external/M2IyMzUxNTZlN2VjNGYzY2I2NDhhNmJmYTFhMWM0Mzc',
  '/countries/:id/pipeline':
    'https://oppizi-ltd.atlassian.net/wiki/external/YTAxOTk2NmI5ZjVkNGY5MDlkMDhhNjYzMDhiOTBiNjE',
  '/countries/:id/settings':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZmI4MDQ3ZWQzNjFiNGZhMmFhYzY3MGQxY2NlNjkyODY',
  '/countries/:id/weather':
    'https://oppizi-ltd.atlassian.net/wiki/external/YzliYzQ1ZTRlNjA1NDk4OTgyNWE1NTFhOGM2OGY3ZGY',
  '/countries/:id/channels':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZGJhZGVmYmI5ZmRjNDZlMDlhYWQ4ZGQxMTAwZWJhMWM',
  // Cities
  '/cities':
    'https://oppizi-ltd.atlassian.net/wiki/external/NWZkZjliMGY5MTVlNDI1YThlMzg3MGQzMTg0OGFjYzA',
  '/cities/add':
    'https://oppizi-ltd.atlassian.net/wiki/external/YzllNTJmYjkxODZmNDc5OThjNmRkYzhjYmJlNjQ3Njg',
  '/cities/:id/edit':
    'https://oppizi-ltd.atlassian.net/wiki/external/NTgwMzA1NjNlYTJiNDk4Mjg4ZDMxOTRmMmUwZjM1NjE',
  '/cities/:id/locations/handtohand':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDU4M2NiYTYzZTI0NDMzZGEwMjA4ZGFmODhlZTEyNmM',
  '/cities/:id/locations/letterbox':
    'https://oppizi-ltd.atlassian.net/wiki/external/MjRhZjI4OWJjNzhlNDQ1NGJmOWEzMjllMDBiOWVjZDU',
  '/cities/:id/global-planning':
    'https://oppizi-ltd.atlassian.net/wiki/external/YmZmZDE2NWRjNTQ3NDg3ZDljNjM3YzdjOTBkNTYzYWQ',
  '/cities/:id/live-map':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZTQyOWNhZWM2ZjUwNDJkYjhlZTM1ZTU5NmMyZmRjZGI',
  '/cities/:id/ambassadors':
    'https://oppizi-ltd.atlassian.net/wiki/external/MDFmMGU2N2VkNzJjNGJhY2I4M2UwODhkMzJkOTY4ZWE',
  '/cities/:id/inventory':
    'https://oppizi-ltd.atlassian.net/wiki/external/MjAzYmNlMDMwZDNlNDJjYmFiZWZlOGJjOWE4ZWIzZDY',
  '/cities/:id/pickup/all':
    'https://oppizi-ltd.atlassian.net/wiki/external/MmY4ZmNkNGI0NTE2NDdkOWI2ZGRjYzU5YjNkZDdhYmU',
  '/cities/:id/stats':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZjI2MzkzNjZiNjMzNDY4NDhlNmE2ZWZiNTAwNTM1OTY',
  '/cities/:id/spy':
    'https://oppizi-ltd.atlassian.net/wiki/external/NDBiZmE3Y2M3NGVmNGIzOGI3YjdmYTRiOGZkODc0YWU',
  '/cities/:id/distribution-zones':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZmNhNTQyNDcyODlmNDY0YmE1ZTYxNTY2NTBhMWM4OTQ',
  // Campaigns
  '/campaigns':
    'https://oppizi-ltd.atlassian.net/wiki/external/N2VhNDFhZGFiNDUwNDIyY2FkZWM4Y2E0MWZlNDIwNDU',
  '/campaigns/create':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZTNkZmE0Y2EyMTI3NDc3M2JlODBlYzA4NDAwZmMwZWY',
  '/campaigns/:id/edit':
    'https://oppizi-ltd.atlassian.net/wiki/external/NzMxNTI5Yjk4NWIyNDIyNDgzMDE3N2ZjMjI1NTc0NmU',
  '/campaigns/:id/live-map':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZmRhZTc2ZDI4ZDJlNDQ0YmFhMzUyYjM5YzIyMjQ3OGI',
  '/campaigns/:id/city-plans':
    'https://oppizi-ltd.atlassian.net/wiki/external/YzlmZDczMzYwMzNhNDE0ZmIwNjY1OTgwOWRhZmYwZWE',
  '/campaigns/:id/master-schedule':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDMxMzI1MmM5MmRkNGRkOGFiMGQ4MDVhMmM5ZjhlZTI',
  '/campaigns/:id/manage-paid-amounts':
    'https://oppizi-ltd.atlassian.net/wiki/external/ODIyNTFmNjkxZWU1NDdkY2IzZDVhMzAyNWUyZWZjMTQ',
  '/campaigns/:id/bonus-results':
    'https://oppizi-ltd.atlassian.net/wiki/external/NzU0MDlmMWU2Yjg0NDY0ZTliNzFkMDQ3Yjg0MTdiZDk',
  '/campaigns/:id/client-questions':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZDJhZDgwNDcwZDljNGQ1ZWE2ZjZiZWZkN2U1ZWM0NTk',
  '/campaigns/:id/internal-files':
    'https://oppizi-ltd.atlassian.net/wiki/external/M2M3N2Q3ZjczYWEyNDZiY2I2MmRiYzM4ODBkOTg1MjI',
  '/campaigns/:id/conversions':
    'https://oppizi-ltd.atlassian.net/wiki/external/ZjdlYmY5NTM1NjI3NDMxZTg1MjNmZDMyMzA2YTRmOGE',
  '/campaigns/:id/logs':
    'https://oppizi-ltd.atlassian.net/wiki/external/MzM1MDAzNzVlNDIwNGNjYjgyYWJkOTY0YjcyMDgxOGU',
}
